import { atcb_action } from 'add-to-calendar-button/unstyle'

const generateCalendarLink = (element, args) => {
  const config = {
    name: args.name,
    description: args.description,
    startDate: args.startDate,
    startTime: args.startTime,
    endDate: args.endDate,
    endTime: args.endTime,
    iCalFileName: args.iCalFileName,
    options: [element.getAttribute('data-calendar-type')],
    hideBranding: true,
  }

  element.addEventListener('click', () => atcb_action(config, element))
}

export default generateCalendarLink
